import pino from 'pino';
import { isExtensionTabMessagingNoise } from './extensionRejectionNoise';

// Create a browser-friendly pino logger
const logger = pino({
  browser: { asObject: true },
  level: (import.meta.env.VITE_LOG_LEVEL as string) || 'info'
});

// Attach contextual data provider (userId) when available
let getUserContext: (() => { userId?: string } | undefined) | undefined;
export function setUserContextProvider(provider: typeof getUserContext) {
  getUserContext = provider;
}

function withContext(fields?: Record<string, unknown>) {
  const ctx = (getUserContext && getUserContext()) || {};
  return { ...ctx, ...fields };
}

// Patch global console to structured logging
const originalConsole = { ...console };

function argsToNoiseString(args: unknown[]): string {
  try {
    return args
      .map((a) => {
        if (a instanceof Error) return `${a.message}\n${a.stack ?? ''}`;
        return typeof a === 'string' ? a : JSON.stringify(a);
      })
      .join(' ');
  } catch {
    return String(args[0]);
  }
}

console.log = (...args: any[]) => logger.info(withContext(), ...args);
console.info = (...args: any[]) => logger.info(withContext(), ...args);
console.warn = (...args: any[]) => logger.warn(withContext(), ...args);
console.error = (...args: any[]) => {
  if (isExtensionTabMessagingNoise(argsToNoiseString(args))) {
    logger.debug(withContext(), ...args);
    return;
  }
  logger.error(withContext(), ...args);
};
console.debug = (...args: any[]) => logger.debug(withContext(), ...args);

// Export a typed logger for direct imports if desired
export const appLogger = logger;

// Allow reverting if needed (for tests)
export function restoreConsole() {
  Object.assign(console, originalConsole);
}


